// This Client should be used when communicating with brazil_frontend,
// where CSRF protections are enabled

import axios from 'axios';
import tagRecordings from '../tracking/hotjar/tagRecordings';
import captureSentryException from '../tracking/sentry/captureSentryException';

const token = document.querySelector('meta[name="csrf-token"]') || { content: 'no-csrf-token' };
const railsAxios = axios.create({
  headers: {
    common: {
      'X-CSRF-Token': token.content,
    },
  },
});

window.axiosActive = 0;
railsAxios.interceptors.request.use((config) => {
  window.axiosActive += 1;
  return config;
});

railsAxios.interceptors.response.use((response) => {
  window.axiosActive -= 1;
  return response;
}, (error) => {
  window.axiosActive -= 1;
  const errorResponse = error.response;

  if (!errorResponse) {
    captureSentryException(error);
    tagRecordings(['axios_error', 'unknown axios error']);
    return Promise.reject(error);
  }

  const { method } = error.config;
  const { status } = errorResponse;
  const endpoint = error.request.responseURL;
  const recordingMsg = `${status}: ${endpoint}`;

  if (status === 400) {
    // Don't log bad requests in Sentry. Use Splunk in the controller instead.
    tagRecordings(['axios_error', recordingMsg]);
    return Promise.reject(error);
  }

  if (window.Sentry !== undefined) {
    window.Sentry.withScope((scope) => {
      // tag errors together based on their request and response
      scope.setTag('method', method);
      scope.setTag('endpoint', endpoint);
      scope.setTag('status', status);
      captureSentryException(error);
    });
  }
  tagRecordings(['axios_error', recordingMsg]);

  if (status === 401) {
    window.location.href = '/login';
  }

  return Promise.reject(error);
});

export default railsAxios;
